import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref, watch, onUnmounted, nextTick } from 'vue';
import * as echarts from 'echarts';
export default {
  __name: 'CapabilityRadar',
  props: {
    data: {
      type: Object,
      required: true
    },
    capabilities: {
      type: Array,
      required: true
    },
    assignedPointData: {
      type: Object,
      required: true
    }
  },

  setup(__props) {
    const radar = ref();
    const chart = ref();
    const props = __props;
    const values = ref([]);
    const maxValue = ref(0);
    const names = ref([]);
    watch(() => props.capabilities, () => {
      values.value = Object.keys(props.data).map(typeId => props.assignedPointData[typeId]);
      maxValue.value = values.value.length !== 0 ? Math.max(...values.value) : 10;
      maxValue.value = parseInt(Math.ceil(maxValue.value / 10 + 1) * 10); // maxValue.value = Math.ceil(maxValue.value / 2 * 5)

      names.value = Object.values(props.data).map(item => ({
        'name': item.desc,
        'min': 0,
        'max': maxValue.value
      })); // console.log(values.value, maxValue.value, names.value)

      nextTick(() => {
        if (chart.value) reloadChartData();
      });
    }, {
      deep: true,
      immediate: true
    });

    const reloadChartData = () => {
      let option = {
        backgroundColor: 'transparent',
        radar: {
          shape: 'circle',
          axisName: {
            show: true,
            formatter: '{value}',
            color: '#4D626E',
            fontSize: '0.7rem'
          },
          axisNameGap: 10,
          splitNumber: 5,
          // interval: 10,
          alignTicks: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#9DA2AE4E'
            }
          },
          splitArea: {
            show: false,
            areaStyle: {
              color: 'transparent'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#9DA2AE4E'
            }
          },
          indicator: names.value,
          axisTick: {
            show: false
          }
        },
        series: [{
          name: '能力点分配',
          type: 'radar',
          data: [{
            value: values.value
          }],
          symbol: 'none',
          lineStyle: {
            width: '1',
            color: '#0D6E6E'
          },
          areaStyle: {
            color: '#0D6E6EA2'
          }
        }]
      };
      chart.value.setOption(option, true);
    };

    onMounted(() => {
      chart.value = echarts.init(radar.value, null, {
        renderer: 'canvas'
      });
      reloadChartData();
      window.addEventListener('resize', updateChart);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', updateChart);
    });

    const updateChart = () => {
      if (chart.value) chart.value.resize();
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "capability-radar",
        ref_key: "radar",
        ref: radar
      }, null, 512);
    };
  }

};